import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpLabeledOperatorGroupFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpLabeledOperatorGroup
 */

export class ExpLabeledOperatorGroupFactory {}
_ExpLabeledOperatorGroupFactory = ExpLabeledOperatorGroupFactory;
_defineProperty(ExpLabeledOperatorGroupFactory, "FromJSON", function (json) {
  return _ExpLabeledOperatorGroupFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpLabeledOperatorGroupFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'sortPriority': json['sortPriority'],
    'label': json['label'],
    'groupID': json['groupID'],
    'defaultExpanded': json['defaultExpanded']
  };
});
_defineProperty(ExpLabeledOperatorGroupFactory, "ToJSON", function (value) {
  return _ExpLabeledOperatorGroupFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpLabeledOperatorGroupFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'sortPriority': value.sortPriority,
    'label': value.label,
    'groupID': value.groupID,
    'defaultExpanded': value.defaultExpanded
  };
});
//# sourceMappingURL=ExpLabeledOperatorGroup.js.map
